import React, { ReactNode, useState, useCallback } from "react";
import { Button } from "../EditorStyles";
import { FormattedMessage } from "react-intl";
import SpinnerWrapper from "./SpinnerWrapper";
import { Modal } from "../../../shared/components/Modal";

interface ConfirmDialogProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  children: ReactNode;
  onConfirm: () => Promise<void>;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ show, setShow, children, onConfirm }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const close = () => setShow(false);

  const confirm = useCallback(async () => {
    setLoading(true);
    await onConfirm();
    setLoading(false);
  }, [onConfirm, setLoading]);

  return (
    <Modal open={show} onClose={close}>
      <SpinnerWrapper loading={loading}>
        <div style={{ marginRight: "50px", maxWidth: "300px" }}>{children}</div>
        <div style={{ display: "flex", justifyContent: "center", gap: "10px", paddingTop: "8px" }}>
          <Button onClick={close}>
            <FormattedMessage id="editor.link.cancel" defaultMessage="Cancel" />
          </Button>
          <Button className="primary" onClick={confirm}>
            <FormattedMessage id="editor.link.confirm" defaultMessage="Confirm" />
          </Button>
        </div>
      </SpinnerWrapper>
    </Modal>
  );
};

export default ConfirmDialog;
